import { Action } from 'redux';
import { Tag } from 'client/types/tag';

export const FETCH_TAG_REQUEST = '@@tag/FETCH_TAG_REQUEST';
export const FETCH_TAG_SUCCESS = '@@tag/FETCH_TAG_SUCCESS';
export const FETCH_TAG_ERROR = '@@tag/FETCH_TAG_ERROR';

export interface FetchTagRequest extends Action {
    type: typeof FETCH_TAG_REQUEST
    payload: string
}

export interface FetchTagSuccess extends Action {
    type: typeof FETCH_TAG_SUCCESS
    payload: Tag
}

export interface FetchTagError extends Action {
    type: typeof FETCH_TAG_ERROR
    payload: Error | string
}

export type TagActionTypes =
    | FetchTagRequest
    | FetchTagSuccess
    | FetchTagError;
